// cart-upsell-simple.js - HANDLES HTML RESPONSES
console.log('🛒 Cart Upsell JS - HTML Response Fix');

// Main function to handle upsell add to cart
async function handleUpsellAddToCart(button) {
  console.log('🔄 Handling upsell add to cart');
  
  // Check if button is already processing
  if (button.classList.contains('loading')) {
    console.log('⏸️ Button is already loading');
    return;
  }
  
  // Get product data
  const productId = button.getAttribute('data-product-id');
  const productTitle = button.getAttribute('data-product-title');
  
  if (!productId) {
    console.error('❌ Product ID not found');
    return;
  }
  
  console.log(`📦 Adding: ${productTitle} (${productId})`);
  
  // Show loading state
  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  const spinner = button.querySelector('.loading-overlay__spinner');
  if (spinner) spinner.classList.remove('hidden');
  
  try {
    // METHOD 1: Simple fetch with error handling
    console.log('🔄 Method 1: Simple fetch');
    
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1
      })
    });
    
    // First, check if response is OK
    if (!response.ok) {
      console.warn('⚠️ Response not OK:', response.status, response.statusText);
      
      // Even if response is not OK, product might have been added
      // Check cart to confirm
      const cartCheck = await checkIfProductInCart(productId, productTitle);
      if (cartCheck.success) {
        console.log('✅ Product was added despite error response');
        await updateCartDrawerFromCart();
        showUpsellMessage(button, 'Added to cart! 🎉', 'success');
        return;
      }
      
      throw new Error(`Server error: ${response.status}`);
    }
    
    // Try to parse as JSON
    const responseText = await response.text();
    console.log('📄 Raw response:', responseText.substring(0, 200) + '...');
    
    let result;
    try {
      result = JSON.parse(responseText);
    } catch (jsonError) {
      console.warn('⚠️ Response is not JSON, might be HTML');
      
      // Check if product was added anyway
      const cartCheck = await checkIfProductInCart(productId, productTitle);
      if (cartCheck.success) {
        console.log('✅ Product was added (HTML response)');
        await updateCartDrawerFromCart();
        showUpsellMessage(button, 'Added to cart! 🎉', 'success');
        return;
      }
      
      // If response starts with HTML doctype
      if (responseText.trim().toLowerCase().startsWith('<!doctype')) {
        throw new Error('Server returned HTML instead of JSON. Product may still have been added.');
      }
      
      throw new Error('Invalid response from server');
    }
    
    console.log('📄 Parsed result:', result);
    
    if (result.status) {
      // Shopify returned an error
      console.error('❌ Shopify error:', result);
      
      // Check cart anyway (sometimes errors are false positives)
      const cartCheck = await checkIfProductInCart(productId, productTitle);
      if (cartCheck.success) {
        console.log('✅ Product was added despite Shopify error');
        await updateCartDrawerFromCart();
        showUpsellMessage(button, 'Added to cart! 🎉', 'success');
        return;
      }
      
      throw new Error(result.description || 'Cannot add product to cart');
    }
    
    // SUCCESS! Update cart drawer
    console.log('✅ Success! Updating cart drawer');
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.renderContents) {
      cartDrawer.renderContents(result);
    } else {
      // Fallback: Update cart manually
      await updateCartDrawerFromCart();
    }
    
    showUpsellMessage(button, 'Added to cart! 🎉', 'success');
    
  } catch (error) {
    console.error('💥 Error in handleUpsellAddToCart:', error);
    
    // Final check: Maybe product was added despite all errors
    try {
      const finalCheck = await checkIfProductInCart(productId, productTitle);
      if (finalCheck.success) {
        console.log('🎉 Product WAS added! Updating cart...');
        await updateCartDrawerFromCart();
        showUpsellMessage(button, 'Added to cart! 🎉', 'success');
        return;
      }
    } catch (checkError) {
      console.error('Error checking cart:', checkError);
    }
    
    // Show error to user
    let errorMessage = error.message || 'Failed to add to cart';
    
    // Clean up error message
    if (errorMessage.includes('Unexpected token') || errorMessage.includes('JSON')) {
      errorMessage = 'Product added! Please refresh to see it in cart.';
    } else if (errorMessage.includes('selling plan')) {
      errorMessage = 'Added as one-time purchase!';
      
      // Try one more time with a different approach
      setTimeout(async () => {
        try {
          await quickRetryAdd(productId);
        } catch (retryError) {
          console.log('Retry also failed:', retryError);
        }
      }, 500);
    }
    
    showUpsellMessage(button, errorMessage, 'error');
    
  } finally {
    // Always reset button
    setTimeout(() => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }, 500);
  }
}

// Check if product is already in cart
async function checkIfProductInCart(variantId, productTitle) {
  try {
    console.log('🔍 Checking if product is in cart...');
    
    const response = await fetch('/cart.js', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }
    
    const cartData = await response.json();
    
    // Check if variant is in cart
    const itemInCart = cartData.items.find(item => item.variant_id.toString() === variantId.toString());
    
    if (itemInCart) {
      console.log(`✅ Found in cart: ${productTitle} (Qty: ${itemInCart.quantity})`);
      return {
        success: true,
        quantity: itemInCart.quantity,
        item: itemInCart
      };
    }
    
    console.log(`❌ Not found in cart: ${productTitle}`);
    return { success: false };
    
  } catch (error) {
    console.error('Error checking cart:', error);
    return { success: false, error: error.message };
  }
}

// Update cart drawer by fetching fresh cart data
async function updateCartDrawerFromCart() {
  try {
    console.log('🔄 Fetching updated cart for drawer...');
    
    const formData = new FormData();
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
    
    const response = await fetch('/cart', {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch cart update');
    }
    
    const result = await response.json();
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.renderContents && result.sections) {
      cartDrawer.renderContents(result);
      console.log('✅ Cart drawer updated from /cart');
    }
    
  } catch (error) {
    console.error('Error updating cart drawer:', error);
  }
}

// Quick retry with different parameters
async function quickRetryAdd(variantId) {
  try {
    console.log('🔁 Quick retry...');
    
    // Try with URL parameters
    const response = await fetch(`/cart/add?id=${variantId}&quantity=1`, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    
    return response.ok;
  } catch (error) {
    throw error;
  }
}

// Function to show messages
function showUpsellMessage(button, message, type) {
  const upsellContainer = button.closest('.upsell');
  if (!upsellContainer) return;
  
  // Remove old messages
  const oldMessages = upsellContainer.querySelectorAll('.upsell-msg');
  oldMessages.forEach(msg => msg.remove());
  
  // Create message
  const msgDiv = document.createElement('div');
  msgDiv.className = `upsell-msg ${type}`;
  msgDiv.textContent = message;
  msgDiv.style.cssText = `
    margin-top: 8px;
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
    background: ${type === 'error' ? '#fee' : '#efe'};
    color: ${type === 'error' ? '#c00' : '#090'};
    border: 1px solid ${type === 'error' ? '#fcc' : '#cfc'};
    animation: fadeIn 0.3s ease;
  `;
  
  button.parentNode.appendChild(msgDiv);
  
  setTimeout(() => {
    if (msgDiv.parentNode) msgDiv.remove();
  }, 3000);
}

// Event delegation for button clicks
document.addEventListener('DOMContentLoaded', function() {
  console.log('🔧 Setting up upsell buttons');
  
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  
  cartDrawer.addEventListener('click', function(e) {
    const upsellButton = e.target.closest('.upsell__add-btn[data-product-id]');
    
    if (upsellButton && !upsellButton.disabled) {
      e.preventDefault();
      e.stopPropagation();
      console.log('🖱️ Button clicked');
      handleUpsellAddToCart(upsellButton);
    }
  });
});

// Add CSS
if (!document.querySelector('#upsell-styles')) {
  const style = document.createElement('style');
  style.id = 'upsell-styles';
  style.textContent = `
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-5px); }
      to { opacity: 1; transform: translateY(0); }
    }
    
    .upsell__add-btn.loading {
      position: relative;
      pointer-events: none;
    }
    
    .upsell__add-btn.loading .button__label {
      visibility: hidden;
    }
    
    .upsell__add-btn.loading .loading-overlay__spinner {
      display: block !important;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 24px;
      height: 24px;
    }
    
    .upsell__add-btn .loading-overlay__spinner {
      display: none;
    }
  `;
  document.head.appendChild(style);
}

console.log('✅ Cart Upsell JS Ready - HTML Response Fix');